import { Box } from "@mui/material"
import React from "react"
import { BSPatioContainer } from "../../../building/BSCreateBuildingPages/BSPatioPage/components/BSPatioContainer"
import { ControlPanelTabHeader } from "../../../components/ControlPanelTabHeader"

interface IProps {
  setIsUpdating: React.Dispatch<React.SetStateAction<boolean>>
}

export function BSPatioTab({ setIsUpdating }: Readonly<IProps>): React.JSX.Element {
  return <BSPatioTabCore />
}
export function BSPatioTabCore(): React.JSX.Element {
  return (
    <Box px={5} pb={2} height="100%" sx={{ overflow: "auto" }}>
      <ControlPanelTabHeader title="Patios" />

      <Box id="bs-patio-list" display="flex" flexDirection="column" alignItems="center" pb={3} gap={3}>
        <BSPatioContainer />
      </Box>
    </Box>
  )
}
